
import { defineComponent, computed, ref } from 'vue';
import { useStore } from '@/store';
import { Vendor } from '@/types/app';
import { alphabetize, lowerCaseIncludes, useModalState } from '@/utils';
import VendorAddEditFormModal from '@/components/modal/VendorAddEditFormModal.vue';
import VendorDeleteModal from '@/components/modal/VendorDeleteFormModal.vue';
import VendorsTable from '@/components/tables/VendorsTable.vue';
import ButtonInput from '@/components/form-controls/base/ButtonInput.vue';
import TextInput from '@/components/form-controls/base/TextInput.vue';
import MaterialIconButton from '@/components/form-controls/MaterialIconButton.vue';

export default defineComponent({
  name: 'VendorsManager',
  components: {
    VendorAddEditFormModal,
    VendorDeleteModal,
    VendorsTable,
    MaterialIconButton,
    TextInput,
    ButtonInput
  },
  setup() {
    const store = useStore();
    const searchValue = ref('');
    const vendors = computed(() => store.getters.vendors.get);
    const filteredVendors = computed(() =>
      vendors.value.filter(
        vendor =>
          lowerCaseIncludes(vendor.name, searchValue.value) ||
          lowerCaseIncludes(vendor.phone, searchValue.value) ||
          lowerCaseIncludes(vendor.location.address, searchValue.value) ||
          vendor.materials.some(material => lowerCaseIncludes(material.material.name, searchValue.value))
      )
    );

    const sortedVendors = computed(() => alphabetize(filteredVendors.value, 'name'));

    const [selectedAddEditVendor, isAddEditModalOpen, openAddEditModal] = useModalState<Vendor>();
    const [selectedDeleteVendor, isDeleteModalOpen, openDeleteModal] = useModalState<Vendor>();

    const handleVendorUpdate = async (vendor: Vendor) => {
      await store.dispatch.vendors.update(vendor);
    };

    return {
      searchValue,
      sortedVendors,
      isAddEditModalOpen,
      openAddEditModal,
      selectedAddEditVendor,
      selectedDeleteVendor,
      isDeleteModalOpen,
      openDeleteModal,
      handleVendorUpdate
    };
  }
});
